import { OptionSelector } from '@src/components';

interface ExpireInFilterBarProps {
  expireInOptions: number[];
  selectedExpireIn: number | null;
  onChange: (value: number | null) => void;
}

export function ExpireInFilterBar({
  expireInOptions,
  selectedExpireIn,
  onChange,
}: Readonly<ExpireInFilterBarProps>) {
  return (
    <OptionSelector
      options={expireInOptions}
      selected={selectedExpireIn}
      onSelect={onChange}
      renderLabel={(value) => (value === 1 ? 'Daily' : `${value} Days`)}
      allOption={{ label: 'All', value: null }}
    />
  );
}
